import validator from "valivalue";

export const validateUuid = (uuid: string, subject = "ID") => {
  validator.objects.validateNotNullOrUndefined(uuid);
  return validator.strings.validateLengthEquals(uuid, 36, subject);
}